var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var TorsoEvents = require('backbone-torso/modules/Events');
var PatientWalletView = require('./../payment-method/PatientWalletView');
var PortalDataService = require('./../data-utils/PortalDataService');
var DemographicsRelatedPersonInfoView = require('./DemographicsRelatedPersonInfoView');
var DemographicsEmploymentView = require('./DemographicsEmploymentView');
var DemographicsSocialHistoryView = require('./DemographicsSocialHistoryView');
var demographicsFeatureConfigModel = require('./demographicsFeatureConfigModel');
var patientDemographicsTemplate = require('./patientDemographicsTemplate.hbs');
var wizardUtils = require('./../wizard/wizardUtils');

/**
 * View for displaying a patients demographics
 *
 * @class PatientDemographicsView
 * @constructor
 */
module.exports = TorsoView.extend(PortalDataService.mixin({
  tagName: 'section',
  className: 'section section--demographics',
  template: patientDemographicsTemplate,

  dataModels: [
    {
      alias: 'demographics',
      modelType: 'demographics',
      dependencies: ['view:demographicsConfigLoaded'],
      id: function() {
        if (demographicsFeatureConfigModel.get('normal.enabled')) {
          return this._patientVecnaId;
        }
      },
      usePull: true
    }
  ],

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   *   @param options.patientVecnaId {String} of the patient owning the demographics
   *   @param options.appointmentExternalId {String} of the appointment
   *   @param options.regDate {String} of the appointments
   */
  initialize: function(options) {

    var view = this;

    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;
    this.isInPreReg = options.appointmentExternalId || options.regDate;
    if(!this.isInPreReg) {
      this._patientWalletView = new PatientWalletView({
        patientVecnaId: this._patientVecnaId
      });
      this.registerTrackedView(this._patientWalletView);
    }

    this.listenTo(demographicsFeatureConfigModel, 'load-complete', this.render);

    _.bindAll(this, '_setDemographicsConfigLoaded');
    demographicsFeatureConfigModel.loadOnce()
      .then(this._setDemographicsConfigLoaded);

    this.on('fetched:demographics', function() {
      view.model = this.getFetched('demographics');
      var normalConfig = demographicsFeatureConfigModel.get('normal');
      var mailInfo = normalConfig.mailInfo;
      var contactInfo = normalConfig.contactInfo;
      var nextOfKin  = normalConfig.nextOfKin;
      var nextOfKin2  = normalConfig.nextOfKin2;
      var emergencyContact  = normalConfig.emergencyContact;
      var emergencyContact2 = normalConfig.emergencyContact2;
      var employmentInfo  = normalConfig.patientEmployment;
      var socialHistoryConfig = this._getSocialHistoryConfigs(normalConfig);

      var wizardPageUrlOptions = {
        appointmentExternalId: this._appointmentExternalId,
        regDate: this._regDate
      };

      if (mailInfo && mailInfo.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditMailInfo';
        this._mailInfoView = new DemographicsRelatedPersonInfoView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.mailInfo',
          config: mailInfo,
          viewName: DemographicsRelatedPersonInfoView.SECTION_NAMES.MAIL_INFO,
          isInPreReg: view.isInPreReg,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditMailInfo',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._mailInfoView);
      }

      if (contactInfo && contactInfo.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditContactInfo';
        this._contactInfoView = new DemographicsRelatedPersonInfoView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.contactInfo',
          config: contactInfo,
          viewName: DemographicsRelatedPersonInfoView.SECTION_NAMES.CONTACT_INFO,
          hasIdImage: !!view.model.get('images.ID.mimeType'),
          isInPreReg: view.isInPreReg,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditContactInfo',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._contactInfoView);
      }

      if (nextOfKin && nextOfKin.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditNextOfKin';
        this._nextOfKinView = new DemographicsRelatedPersonInfoView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.nextOfKin',
          config: nextOfKin,
          viewName: DemographicsRelatedPersonInfoView.SECTION_NAMES.NEXT_OF_KIN,
          isInPreReg: view.isInPreReg,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditNextOfKin',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._nextOfKinView);
      }

      if (nextOfKin2 && nextOfKin2.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditNextOfKin2';
        this._nextOfKin2View = new DemographicsRelatedPersonInfoView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.nextOfKin2',
          config: nextOfKin2,
          viewName: DemographicsRelatedPersonInfoView.SECTION_NAMES.NEXT_OF_KIN_2,
          isInPreReg: view.isInPreReg,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditNextOfKin2',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._nextOfKin2View);
      }

      if (emergencyContact && emergencyContact.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditEmergency';
        this._emergencyContactView = new DemographicsRelatedPersonInfoView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.emergencyContact',
          config: emergencyContact,
          viewName: DemographicsRelatedPersonInfoView.SECTION_NAMES.EMERGENCY_CONTACT,
          isInPreReg: view.isInPreReg,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditEmergency',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._emergencyContactView);
      }

      if (emergencyContact2 && emergencyContact2.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditEmergency2';
        this._emergencyContact2View = new DemographicsRelatedPersonInfoView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.emergencyContact2',
          config: emergencyContact2,
          viewName: DemographicsRelatedPersonInfoView.SECTION_NAMES.EMERGENCY_CONTACT_2,
          isInPreReg: view.isInPreReg,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditEmergency2',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._emergencyContact2View);
      }

      if (socialHistoryConfig && socialHistoryConfig.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditSocialHistory';
        this._socialHistoryView = new DemographicsSocialHistoryView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties',
          config: socialHistoryConfig,
          isInPreReg: view.isInPreReg,
          appointmentExternalId: view._appointmentExternalId,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditSocialHistory',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._socialHistoryView);
      }

      if (employmentInfo && employmentInfo.enabled) {
        wizardPageUrlOptions.hash = 'appointmentPreRegDemographicsEditEmployment';
        this._employmentView = new DemographicsEmploymentView({
          dataModel: view.model,
          dataProperty: 'demographicsWithPendingProperties.employmentInfo',
          config: employmentInfo,
          isInPreReg: view.isInPreReg,
          appointmentExternalId: view._appointmentExternalId,
          editUrl: '/patient-portal/secure/portal.html#demographicsEditEmployment',
          preRegEditUrl: wizardUtils.getVccPageUrl(wizardPageUrlOptions)
        });
        this.registerTrackedView(this._employmentView);
      }
    });
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var context = TorsoView.prototype.prepare.apply(this);
    context.demographicsConfig = demographicsFeatureConfigModel.toJSON();
    return context;
  },

  /**
   * Trigger validation on subviews
   * @method postrender
   * @override
   */
  postrender:function() {
    TorsoEvents.trigger('demographics:validate');
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    if (this._patientWalletView) {
      this.attachView('patient-wallet', this._patientWalletView);
    }
    if (this._mailInfoView) {
      this.attachView('patient-mail-info', this._mailInfoView);
    }
    if (this._contactInfoView) {
      this.attachView('patient-contact-info', this._contactInfoView);
    }
    if (this._nextOfKinView) {
      this.attachView('patient-next-of-kin', this._nextOfKinView);
    }
    if (this._nextOfKin2View) {
      this.attachView('patient-next-of-kin-2', this._nextOfKin2View);
    }
    if (this._emergencyContactView) {
      this.attachView('patient-emergency-contact', this._emergencyContactView);
    }
    if (this._emergencyContact2View) {
      this.attachView('patient-emergency-contact-2', this._emergencyContact2View);
    }
    if (this._socialHistoryView) {
      this.attachView('patient-social-history', this._socialHistoryView);
    }
    if (this._employmentView) {
      this.attachView('patient-employment', this._employmentView);
    }
  },


  /**
   * @method   _getSocialHistoryConfigs: function (normalConfig) {
   * @param normalConfig config containing miscellanous fields that are grouped into social history
   * @return {Object} configuration object for social history section
   * @private
   */
  _getSocialHistoryConfigs: function (normalConfig) {
    var socialHistoryConfig = {
      speakEnglish: normalConfig.speakEnglish,
      primaryLanguage: normalConfig.primaryLanguage,
      preferredLanguage: normalConfig.preferredLanguage,
      needInterpreter: normalConfig.needInterpreter,
      needAssistance: normalConfig.needAssistance,
      typeOfAssistance: normalConfig.typeOfAssistance,
      ethnicity: normalConfig.ethnicity,
      race: normalConfig.race,
      additionalRace: normalConfig.additionalRace,
      maritalStatus: normalConfig.maritalStatus,
      religion: normalConfig.religion,
      congregation: normalConfig.congregation,
      birthCountry: normalConfig.birthCountry,
      birthState: normalConfig.birthState,
      birthCity: normalConfig.birthCity
    };

    var sectionIsEnabled = _.any(socialHistoryConfig, function (fieldConfig) {
      return fieldConfig.fieldPermissions && fieldConfig.fieldPermissions !== 'DISABLED';
    });

    socialHistoryConfig.enabled = sectionIsEnabled;

    return socialHistoryConfig;
  },

  /**
   * @method _setDemographicsConfigLoaded
   * @private
   */
  _setDemographicsConfigLoaded: function() {
    this.set('demographicsConfigLoaded', true);
  }
}));
